import axiosInstance from "../../axios";
import {showSuccessDialog} from "../../components/dialogs/dialogs";
import {fetchWishlist} from "./wishlist";

// Action Types
export const PRODUCT_DETAIL_REQUEST = 'PRODUCT_DETAIL_REQUEST';
export const PRODUCT_DETAIL_SUCCESS = 'PRODUCT_DETAIL_SUCCESS';
export const PRODUCT_DETAIL_FAILURE = 'PRODUCT_DETAIL_FAILURE';
export const ADD_TO_WISHLIST = 'ADD_TO_WISHLIST';
export const REMOVE_FROM_WISHLIST = 'REMOVE_FROM_WISHLIST';

// Action Creators
export const productDetailRequest = () => ({
    type: PRODUCT_DETAIL_REQUEST,
});

export const productDetailSuccess = (productDetail, subProducts, images) => ({
    type: PRODUCT_DETAIL_SUCCESS,
    payload: {
        productDetail,
        subProducts,
        images
    },
});

export const productDetailFailure = (error) => ({
    type: PRODUCT_DETAIL_FAILURE,
    payload: error,
});

export const addToWishlist = () => ({
    type: ADD_TO_WISHLIST,
});

export const removeFromWishlist = () => ({
    type: REMOVE_FROM_WISHLIST,
});

// Thunk Action Creator
export const fetchProductDetail = (productId) => async (dispatch) => {
    try {
        dispatch(productDetailRequest());

        const response = await axiosInstance.get(`product/${productId}`);
        const responseData = response.data;

        console.log(responseData);

        // Ensure subProducts have stock_count if not provided by API
        const enhancedSubProducts = (responseData.subProducts || []).map((sp) => ({
            ...sp,
            stock_count: sp.stock_count || (sp.stock_type === 'IN STOCK' ? 12 : 0)
        }));

        dispatch(productDetailSuccess(
            responseData.data,
            enhancedSubProducts,
            responseData.images || []
        ));
    } catch (error) {
        let errorMessage = 'Unknown error';

        if (error.message) {
            errorMessage = error.message;
        }

        dispatch(productDetailFailure(errorMessage));
    }
};

// Toggle wishlist status
export const toggleWishlist = (productId, currentStatus) => async (dispatch) => {
    try {
        // Optimistically update UI
        if (currentStatus) {
            dispatch(removeFromWishlist());
        } else {
            dispatch(addToWishlist());
        }

        // Make API call to update wishlist status
        await axiosInstance.post(`favorite/${currentStatus ? 'remove' : 'add'}/${productId}`);
    } catch (error) {
        console.log(error);
        // Revert optimistic update if API call fails
        if (currentStatus) {
            dispatch(addToWishlist());
        } else {
            dispatch(removeFromWishlist());
        }
    }
};


export const addWishlist=(object)=> async (dispatch) => {
    try {
        const res = await axiosInstance.post('product/wishlist/add',object);
        if (res.data.code === 1) {
            dispatch(fetchWishlist())
            showSuccessDialog(res.data.message);
        }
    } catch (error) {
        console.log(error)
    }
}

// Initial State
const initialState = {
    loading: false,
    productDetail: null,
    subProducts: [],
    images: [],
    error: null
};

// Reducer
export const productDetailReducer = (state = initialState, action) => {
    switch (action.type) {
        case PRODUCT_DETAIL_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case PRODUCT_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                productDetail: action.payload.productDetail,
                subProducts: action.payload.subProducts,
                images: action.payload.images,
                error: null
            };

        case PRODUCT_DETAIL_FAILURE:
            return {
                ...state,
                loading: false,
                productDetail: null,
                subProducts: [],
                images: [],
                error: action.payload
            };

        case ADD_TO_WISHLIST:
            return {
                ...state,
                productDetail: state.productDetail
                    ? { ...state.productDetail, wishlist: true }
                    : null
            };

        case REMOVE_FROM_WISHLIST:
            return {
                ...state,
                productDetail: state.productDetail
                    ? { ...state.productDetail, wishlist: false }
                    : null
            };

        default:
            return state;
    }
};